<template>
    <div>
        <div class="col-md-12 mt-3">
            <div class=" container-bg p-4">
                <div class="row">
                    <div class="col-12">
                        <h3 class="text-uppercase">Items</h3>
                    </div>

                </div>
                <div class="row mt-4">
                    <div class="col-md-4">

                        <div class="form-group" style=" margin-left: 85px;">
                            <select class="form-control" id="exampleFormControlSelect1" style="background-color: #292929; color: white;">
                                <option>Item Name</option>
                                <option>2</option>
                                <option>3</option>
                                <option>4</option>
                                <option>5</option>
                            </select>
                        </div>

                    </div>
                    <div class="col-md-5 col-12">
                        <div class="float-right">
                            <input class="search-box" type="text" placeholder="Zoeken">
                            <button class="search-btn" ><img
                                    src="/assets/img/search.svg" alt="Search"
                                    style="margin-bottom: 4px"></button>
                        </div>
                    </div>
                    <div class="col-md-2" >
                        <button class="btn btn-dark">Export</button>
                    </div>
                    <div class="col-md-1" style="margin-left: -21px;margin-top: 5px;">
                        <i class="fa fa-plus float-right mt-1" data-toggle="modal" data-target="#newItemgroup"
                           style="font-size: 24px;cursor: pointer"></i>
                    </div>
                </div>


                <div class="flex-container flex-body mt-3" data-toggle="collapse" data-target="#next" style="cursor:pointer;">
                    <div class="item text-center" style="flex: 2.2">
                        <img    src="/assets/img/star.svg"
                                alt=""
                        >
                    </div>
                    <div class="item text-white" style="flex: 3.2">We will rock you</div>
                    <div class="item text-white" style="flex: 7.1;text-align: right;margin-right: 10%;"> Rock > Genre > Music</div>

                    <div class="item text-white" style="flex: 2">
                        <a class="text-white" style="margin-right:10px"><i class="fa fa-trash" aria-hidden="true" data-toggle="modal" data-target="#deleteModal"></i></a>
                        <a class="text-white" style="margin-right:10px"><i class="fa fa-plus" aria-hidden="true" data-toggle="modal" data-target="#addfileModal"></i></a>
                        <a class="text-white" style="margin-right:10px"><i class="fa fa-pencil"></i></a>
                        <a class="text-white"><i class="fa fa-lock" aria-hidden="true"></i></a>
                    </div>
                </div>
                <div id="next" class="collapse" style="margin-top: 18px; width: 92%; margin-left: 35px;">
                    <div class="row" style="background-color: white; height: 80px;padding-top: 25px; padding-left: 40px;">

                        <div class="col-lg-6 col-md-12 col-12">
                            <div class="row">
                                <div class="col-lg-2 col-md-3 col-3">
                                    <img src="/assets/img/Docicon.svg" alt="" >
                                </div>
                                <div class="col-lg-6 col-md-6 col-6">
                                    <span>Document title lorem</span>
                                </div>
                                <div class="col-lg-4 col-md-3 col-3">
                                    <a class="" style="margin-right:10px"><i class="fa fa-trash" aria-hidden="true" data-toggle="modal" data-target="#deleteModal"></i></a>
                                    <a class=""><i class="fa fa-pencil"></i></a>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-6 col-md-12 col-12">
                            <div class="row">
                                <div class="col-lg-2 col-md-3 col-3">
                                    <img src="/assets/img/Docicon.svg" alt="" >
                                </div>
                                <div class="col-lg-6 col-md-6 col-6">
                                    <span>Document title lorem</span>
                                </div>
                                <div class="col-lg-4 col-md-3 col-3">
                                    <a class="" style="margin-right:10px"><i class="fa fa-trash" aria-hidden="true" data-toggle="modal" data-target="#deleteModal"></i></a>
                                    <a class=""><i class="fa fa-pencil"></i></a>
                                </div>
                            </div>
                        </div>


                    </div>
                    <div class="row" style="background-color: white; height: 80px; padding-top: 25px; padding-left: 40px;">

                        <div class="col-lg-6 col-md-12 col-12">
                            <div class="row">
                                <div class="col-lg-2 col-md-3 col-3">
                                    <img src="/assets/img/Docicon.svg" alt="" >
                                </div>
                                <div class="col-lg-6 col-md-6 col-6">
                                    <span>Document title lorem</span>
                                </div>
                                <div class="col-lg-4 col-md-3 col-3">
                                    <a class="" style="margin-right:10px"><i class="fa fa-trash" aria-hidden="true" data-toggle="modal" data-target="#"></i></a>
                                    <a class=""><i class="fa fa-pencil"></i></a>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-6 col-md-12 col-12">
                            <div class="row">
                                <div class="col-lg-2 col-md-3 col-3">
                                    <img src="/assets/img/Docicon.svg" alt="" >
                                </div>
                                <div class="col-lg-6 col-md-6 col-6">
                                    <span>Document title lorem</span>
                                </div>
                                <div class="col-lg-4 col-md-3 col-3">
                                    <a class="" style="margin-right:10px"><i class="fa fa-trash" aria-hidden="true" data-toggle="modal" data-target="#"></i></a>
                                    <a class=""><i class="fa fa-pencil"></i></a>
                                </div>
                            </div>
                        </div>


                    </div>
                </div>

            </div>
        </div> 
        <!-- Modal -->
        <div class="modal fade" id="newItem" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle"
             aria-hidden="true">
            <div class="modal-dialog " role="document">
                <div class="modal-content">
                    <div class="modal-header" style="border-bottom: unset">
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">

                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "items",
    }
</script>

<style scoped>
    .flex-container {
        display: flex;
        flex-flow: row wrap;
        position: relative;
        width: auto;
        align-items: center;
        margin-top: 10px;
        opacity: 1;
    }

    .flex-body {
        background: #4192D9 0% 0% no-repeat padding-box;
        box-shadow: 1px 5px 10px #0000004B;
        border-radius: 20px;
    }

    .item {
        flex: 1 1 18%;
        height: auto;
        margin: 4px;
        margin-right: 10px;
        padding: 10px 0;
        width: auto;
    }
    .search-box {
        background: #FFFFFF 0% 0% no-repeat padding-box;
        border: 1px solid #292929;
        border-radius: 4px;
        height: 40px;
        width: 20rem;
    }

    .search-btn {
        background: transparent;
        border: unset;
        margin-left: -30px;

        -webkit-appearance: none;
    }
</style>
